var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, LoadingPane, Modal } from "@folio/stripes/components";
import { fetchProductById, updateProduct, updateProductAccessibility, } from "../../api/productService";
import ProductForm from "./ProductForm";
import { ProductAccessibilityEnum } from "../../types/Api";
import { MAKE_PUBLIC_PARAM } from "../../utils/urlParams";
import { useModal } from "../../utils/useModal";
var ProductEdit = function () {
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var id = useParams().id;
    var makePublicAfterSave = useState(function () {
        return new URLSearchParams(location.search).get(MAKE_PUBLIC_PARAM) === "true";
    })[0];
    var _a = useModal(), isOpen = _a.isOpen, message = _a.message, openModal = _a.openModal, closeModal = _a.closeModal;
    var _b = useState(null), product = _b[0], setProduct = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        if (queryParams.has(MAKE_PUBLIC_PARAM)) {
            queryParams.delete(MAKE_PUBLIC_PARAM);
            history.replace({ search: queryParams.toString() });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading(true);
                        return [4 /*yield*/, fetchProductById(ky, id)];
                    case 1:
                        data = _a.sent();
                        setProduct(data);
                        setError(null);
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        setError("Failed to load product data");
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    var goToDetail = function () {
        history.push("/bragency/products?detail=".concat(id));
    };
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, updateProduct(ky, data)];
                case 1:
                    _c.sent();
                    if (!makePublicAfterSave) return [3 /*break*/, 5];
                    if (!((_a = data.publishingDate) === null || _a === void 0 ? void 0 : _a.trim())) {
                        openModal(formatMessage({
                            id: "ui-br-agency.product.makePublic.afterSave.missingDate",
                        }));
                        return [2 /*return*/];
                    }
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, updateProductAccessibility(ky, (_b = data.id) !== null && _b !== void 0 ? _b : id, ProductAccessibilityEnum.PUBLIC)];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_2 = _c.sent();
                    openModal(formatMessage({
                        id: "ui-br-agency.product.makePublic.afterSave.failed",
                    }));
                    return [2 /*return*/];
                case 5:
                    goToDetail();
                    return [2 /*return*/];
            }
        });
    }); };
    if (isLoading) {
        return React.createElement(LoadingPane, null);
    }
    if (error || !product) {
        return (React.createElement("div", null,
            "Error:",
            " ",
            error || formatMessage({ id: "ui-br-agency.product.not.found" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductForm, { initialValues: product, onSubmit: handleSubmit, title: formatMessage({
                id: "ui-br-agency.product.edit.pane.title",
            }), infoMessage: makePublicAfterSave
                ? formatMessage({
                    id: "ui-br-agency.product.makePublic.afterSave.banner",
                })
                : undefined }),
        React.createElement(Modal, { open: isOpen, label: formatMessage({
                id: "ui-br-agency.product.makePublic.afterSave.modal.label",
            }), footer: React.createElement(Button, { buttonStyle: "primary", onClick: function () {
                    closeModal();
                    goToDetail();
                } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.ok" })) }, message)));
};
export default ProductEdit;
